import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { login, logout } from './AuthSlice'
const apiURL = process.env.REACT_APP_BACKEND

const initialState = {
  sites: [],
  siteLoaded: false,
}

export const getSites = createAsyncThunk('site/getSites', async (_, thunkAPI) => {
  // access the entire redux state
  const state = thunkAPI.getState()
  const { authId, webToken, subscriberId, customerId, siteId } = state.auth
  const { onsiteSiteId } = state.onsite

  let siteURL;
  if (authId === 100) {
    siteURL = 'api/gatesitesNew/';
  } else if (authId === 1) {
    siteURL = 'api/gatesitesNew/subscriber/' + subscriberId;
  } else if (authId === 2 || authId === 4) {
    siteURL = 'api/gatesitesNew/customer/' + customerId;
  } else {
    // this is a guard, so let's get only the site of the gate it is assigned to
    siteURL = 'api/gatesitesNew/id/' + siteId;
  }

  return await fetch(apiURL + siteURL, {
    method: 'get',
    headers: { 'Accept': 'application/json', 'Authorization': webToken },
    credentials: 'include'
  })
  .then(response => response.json())
  .then(data => {
    let ret = {sites: data}
    ret.onsiteSiteId = !onsiteSiteId && data && data[0] && data[0].id ? data[0].id : onsiteSiteId
    return ret
  })
  .catch(error => {
      console.error('Error:', error)
      return []
  })
});

const siteSlice = createSlice({
  name: 'site',
  initialState,
  reducers: {
    setSiteSlice: (state, action) => {
      state[action.payload.field] = action.payload.value
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSites.fulfilled, (state, action) => {
        state.sites = action.payload.sites
      })
      .addCase(login, (state, action) => {
        state.siteLoaded = true
      })
      .addCase(logout, (state, action) => {
        return { ...initialState }
      })
  },
})

export const { setSiteSlice } = siteSlice.actions
export default siteSlice.reducer
